import React from 'react';
import { getIn, useFormikContext } from 'formik';

import { CurrencyFormatterContextProvider, useCurrencyFormatter } from '../CurrencyFormatterContext';
import { MonetaryValueTextFieldFormik } from '../TextFieldFormik';

interface AmountFieldWithCurrencyDisplayProps {
  requestCurrency?: string;
  id: string;
  label: string;
  policyCurrency?: string;
  conversionRate?: number;
  [key: string]: unknown; // for ...props spread
}

const AmountFieldWithCurrencyDisplay: React.FC<AmountFieldWithCurrencyDisplayProps> = ({
  requestCurrency,
  id,
  label,
  policyCurrency,
  conversionRate,
  ...props
}) => {
  const { values } = useFormikContext();
  const { currencyFormatter } = useCurrencyFormatter();

  const currentAmount = getIn(values, id);

  const enhancedLabel =
    requestCurrency && conversionRate
      ? `${label} (${currencyFormatter.format(currentAmount / conversionRate, policyCurrency)})`
      : label;

  return (
    <CurrencyFormatterContextProvider currency={requestCurrency}>
      <MonetaryValueTextFieldFormik id={id} label={enhancedLabel} {...props} />
    </CurrencyFormatterContextProvider>
  );
};

export default AmountFieldWithCurrencyDisplay;
